import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getRequest} from "@/utils/api";

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
    // start progress bar
    NProgress.start()
    // set page title
    // to 要去的路由; from 来自哪里的路由 ; next() 放行
    // 用户登录成功时，把 token 存入 localStorage，如果携带 token，初始化菜单，放行
    if (window.localStorage.getItem('tokenStr')) {
        // 如果用户不存在
        if (!window.localStorage.getItem('user')) {
            // 判断用户信息是否存在
            return getRequest('/worker/info').then(resp => {
                if (resp) {
                    // 存入用户信息，转字符串，存入 localStorage
                    window.localStorage.setItem('user', JSON.stringify(resp.data))
                    // 同步用户信息 编辑用户

                    store.dispatch('INIT_WORKER', resp.data)
                    // store.commit('INIT_ADMIN', resp.data)
                    NProgress.done()
                    next();
                }
            })
        }
        NProgress.done()
        next();
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            NProgress.done()
            next()
        } else {
            NProgress.done()
            next('/login')
        }
    }
})

router.afterEach(() => {
    // finish progress bar
    NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js